module.exports = __webpack_public_path__ + "static/img/per12.8275b97.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/per12.jpg
// module id = jOTn
// module chunks = 41